import ChannelLogo from '@components/atoms/images/channelLogo';
import ChannelServices from '@components/elements/services/services';
import EventTitle from '@components/atoms/text/eventTitle';
import PilotChannelLogoContainer from '@components/atoms/container/pilotChannelLogoContainer';
import PilotChannelTitle from '@components/atoms/text/pilotChannelTitle';
import PilotChannelTitleContainer from '@components/atoms/container/pilotChannelTitleContainer';
import { channelsSelector } from '@shared/store/slices/channels.slice';
import { useAppSelector } from '@shared/store/hooks';
import { playerSelector } from '@shared/store/slices/player.slice';

interface Props {
  id?: string;
  logo?: string;
  subtitle?: string;
  title?: string;
  type?: string;
}

export default function PilotEvent({ id, logo, subtitle, title, type }: Props) {
  const { currentChannel } = useAppSelector(channelsSelector);
  const {
    nextEpisode: { display: displayNextEpisode },
  } = useAppSelector(playerSelector);
  return (
    <>
      {/* Channel logo */}
      <PilotChannelLogoContainer>
        <ChannelLogo key={id} disableMargin={true} src={logo} />
      </PilotChannelLogoContainer>
      {/* Channel title */}
      <PilotChannelTitleContainer>
        <PilotChannelTitle>{title ?? ''}</PilotChannelTitle>
        {type === 'channel' ? (
          <ChannelServices channel={currentChannel} />
        ) : null}
      </PilotChannelTitleContainer>
      {/* Channel event title */}
      {subtitle && (
        <EventTitle shrink={displayNextEpisode}>{subtitle ?? ''}</EventTitle>
      )}
    </>
  );
}
